module.exports = __webpack_public_path__ + "img/2.bfd4d57c.png";